import { memo } from "react";

import { SimpleOptionT } from "@interfaces/company/employees";
import clsx from "clsx";
import s from "./drop-down-select.module.scss";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

interface DropDownSelectProps {
  title: string;
  options: SimpleOptionT[];
  value?: SimpleOptionT;
  onChange: (value: SimpleOptionT) => void;
  className?: any;
}

export const DropDownSelect: React.FC<DropDownSelectProps> = memo((props) => {
  const { title, value, options, onChange } = props;

  const onClickHandler = (event: SelectChangeEvent) => {
    console.log(options, event.target.value);
    onChange(
      options.find(
        (e) => e.value === parseInt(event.target.value)
      ) as SimpleOptionT
    );
  };

  return (
    <>
      <div className={clsx(s.container)}>
        <FormControl variant="filled" size="small" fullWidth>
          <InputLabel id={`drop-down-select-${options.length}`}>
            {title}
          </InputLabel>
          <Select
            labelId={`drop-down-select-${options.length}`}
            value={value?.value.toString()}
            onChange={onClickHandler}
            className={s.select}
          >
            {options.map((option) => (
              <MenuItem value={option.value}>{option.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </>
  );
});
